/* === AgBackdrop — Anagogia Design System === */

import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './AgBackdrop.module.css';

export interface AgBackdropProps {
  open: boolean;
  onClick?: () => void;
  transparent?: boolean;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Voile d'arrière-plan des surfaces modales.
 * @category Overlays
 */
function AgBackdrop({ open, onClick, transparent, className, children }: AgBackdropProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [open]);

  const cls = [
    styles.backdrop,
    open && styles.open,
    transparent && styles.transparent,
    className,
  ].filter(Boolean).join(' ');

  return createPortal(
    <div className={cls} onClick={onClick} aria-hidden={!open}>
      {children}
    </div>,
    document.body,
  );
}

export { AgBackdrop };
export default AgBackdrop;
